module.exports = __webpack_public_path__ + "img/2x3_collage.3b4f8331.jpg";